
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { MultiRowsBlockListItemModel, MultiRowsBlockSettingsModel } from 'fourwaves-shared';
import MultiRowsBlockListItem from './MultiRowsBlockListItem.vue';

@Component({
  components: {
    MultiRowsBlockListItem,
  },
})
export default class MultiRowsBlockList extends Vue {
  @Prop({ type: Array, required: true }) readonly items!: MultiRowsBlockListItemModel[];
  @Prop({ type: Object, required: true }) readonly settings!: MultiRowsBlockSettingsModel;
}
